import template from './invoicePreviewModal.html';
import controller from './invoicePreviewModal.controller';

let InvoicePreviewModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'lg',
  windowClass: "invoice-modal-popup hmodal-warning animated zoomIn"
};

export default InvoicePreviewModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/InvoicePreviewModal/invoicePreviewModal.component.js